import { render, staticRenderFns } from "./jicaiListMy.vue?vue&type=template&id=3db70f78&"
import script from "./jicaiListMy.vue?vue&type=script&lang=js&"
export * from "./jicaiListMy.vue?vue&type=script&lang=js&"
import style0 from "./jicaiListMy.vue?vue&type=style&index=0&id=3db70f78&prod&lang=less&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports